<div class="marketing social-media">
  <h3 class="social-media-title">INTEGRAÇÕES SOCIAL MEDIA</h3>
  @if (error) {
    <div class="marketing-error" role="alert">
      {{ error }}
      <app-button styleType="clean" icon="pi pi-refresh" [disabled]="busy" (btnClick)="selectTab(tab)"
        >Tentar novamente</app-button
      >
    </div>
  }
  @if (notice) {
    <p class="marketing-notice" role="status">{{ notice }}</p>
  }
  <p-tabs [scrollable]="true" [value]="tab" (valueChange)="changeTab($event)">
    <p-tablist aria-label="Marketing do evento">
      <p-tab value="results">Resultados</p-tab>
      <p-tab value="integrations">Integrações de anúncios</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="results">
        <ng-container *ngTemplateOutlet="resultsPanel"></ng-container>
      </p-tabpanel>
      <p-tabpanel value="integrations">
        <ng-container *ngTemplateOutlet="integrationsPanel"></ng-container>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #resultsPanel>
    @if (tab === "results") {
      <section class="card marketing-surface marketing-report">
        <h3>RESULTADOS DE DIVULGAÇÃO</h3>
        <p>
          Origem dos pedidos pagos deste evento. UTMs são reconhecidas automaticamente, sem cadastro prévio de links ou
          pixels.
        </p>
        <form class="marketing-filters" (ngSubmit)="filter()">
          <label class="marketing-date-field"
            >Pagamento a partir de<input
              class="form-control"
              type="date"
              name="start"
              [(ngModel)]="filters.start_date"
              required /><img src="assets/marketing/social-media/calendar.svg" alt="" width="15" height="15"
          /></label>
          <label class="marketing-date-field"
            >Pagamento antes de (exclusivo)<input
              class="form-control"
              type="date"
              name="end"
              [(ngModel)]="filters.end_date"
              required /><img src="assets/marketing/social-media/calendar.svg" alt="" width="15" height="15"
          /></label>
          <label
            >Origem<select class="form-select" name="source" [(ngModel)]="filters.source" [disabled]="busy">
              <option value="">Todas</option>
              @for (value of dimensionOptions("source"); track value) {
                <option [value]="value">{{ dimensionLabel("source", value) }}</option>
              }
            </select></label
          >
          <label
            >Meio de marketing<select class="form-select" name="medium" [(ngModel)]="filters.medium" [disabled]="busy">
              <option value="">Todos</option>
              @for (value of dimensionOptions("medium"); track value) {
                <option [value]="value">{{ dimensionLabel("medium", value) }}</option>
              }
            </select></label
          >
          <label
            >Campanha<select class="form-select" name="campaign" [(ngModel)]="filters.campaign" [disabled]="busy">
              <option value="">Todas</option>
              @for (value of dimensionOptions("campaign"); track value) {
                <option [value]="value">{{ value }}</option>
              }
            </select></label
          >
          <label
            >Canal de venda<select class="form-select" name="channel" [(ngModel)]="filters.sale_channel">
              <option value="online">Online</option>
              <option value="pdv_portaria">PDV Evento</option>
              <option value="pdv_seller">PDV Yes7</option>
              <option value="all">Todos os canais</option>
            </select></label
          >
          <label
            >Meio de pagamento<select class="form-select" name="payment" [(ngModel)]="filters.payment_method">
              <option value="">Todos</option>
              <option value="pix">Pix</option>
              <option value="credit_card">Cartão</option>
              <option value="cash">Dinheiro</option>
            </select></label
          >
          <app-button type="submit" [disabled]="busy">Filtrar</app-button>
          <app-button styleType="outlined" (btnClick)="download()" [disabled]="busy || !report"
            >Baixar relatório</app-button
          >
        </form>
        <p class="marketing-hint">
          @if (hideMoney) {
            As listas mostram as origens encontradas nas vendas do período, canal e meio de pagamento consultados.
          } @else {
            As listas mostram valores encontrados nas vendas do período, canal e meio de pagamento consultados.
          }
          Para atualizar esse recorte, clique em Filtrar.
        </p>
        <p class="marketing-hint">
          Período de pagamento · America/Sao_Paulo · Última origem não direta em 30 dias. PDV não recebe atribuição
          publicitária online.
        </p>
        @if (busy) {
          <p role="status">Carregando resultados…</p>
        }
        @if (report; as result) {
          @if (pendingFilters) {
            <p class="marketing-warning" role="status">
              Filtros alterados. Clique em Filtrar para atualizar os resultados. O CSV usa o último filtro aplicado.
            </p>
          }
          @if (recordingGapCount(result) || result.metadata.refund_reviews) {
            <div class="marketing-warning marketing-reconciliation" role="status">
              @if (recordingGapCount(result); as gaps) {
                <p>
                  {{ gaps }} pedidos com evidência pendente de conciliação não entram nos totais.
                  @if (!hideMoney) {
                    Nenhum valor foi estimado.
                  }
                </p>
              }
              @if (!hideMoney && result.metadata.refund_reviews; as reviews) {
                <p>
                  {{ reviews }} estorno(s) em revisão: a reversão de receita ainda não está confirmada. Os valores após
                  estornos podem mudar.
                </p>
              }
            </div>
          }
          <div class="marketing-metrics">
            <article>
              <span>Pedidos pagos</span><strong>{{ result.summary.paid_orders }}</strong>
            </article>
            <article>
              <span>Unidades comerciais</span><strong>{{ result.summary.commercial_units }}</strong>
            </article>
            @if (!hideMoney) {
              <article>
                <span>Receita de ingressos</span
                ><strong>{{ result.summary.ticket_revenue_cents / 100 | currency: "BRL" }}</strong>
              </article>
            }
            <article>
              <span>Origem identificada (online)</span
              ><strong>
                @if (result.summary.online_orders) {
                  {{ result.summary.coverage_percent | number: "1.1-1" }}%
                } @else {
                  Sem base online
                }</strong
              ><small>{{ result.summary.identified_orders }} de {{ result.summary.online_orders }} pedidos</small>
            </article>
          </div>
          @if (!hideMoney) {
            <p class="marketing-hint marketing-refunds">
              Receita de ingressos estornada: {{ result.summary.refund_cents / 100 | currency: "BRL" }} · Receita após
              estornos:
              {{ result.summary.revenue_after_refunds_cents / 100 | currency: "BRL" }}
            </p>
          }
          <div class="marketing-table marketing-origin-table">
            @if (result.funnel; as funnel) {
              <details class="marketing-funnel">
                <summary>Funil online medido</summary>
                @if (funnel.available && funnel.sessions; as stages) {
                  <div class="marketing-metrics">
                    <article>
                      <span>Sessões com visualização</span><strong>{{ stages.event_viewed }}</strong>
                    </article>
                    <article>
                      <span>Com adição ao carrinho</span><strong>{{ stages.cart_item_added }}</strong>
                    </article>
                    <article>
                      <span>Com início de checkout</span><strong>{{ stages.checkout_started }}</strong>
                    </article>
                    <article>
                      <span>Com compra confirmada</span><strong>{{ stages.purchase_confirmed }}</strong>
                    </article>
                  </div>
                  <p>
                    Conversão das sessões medidas:
                    @if (funnel.conversion_percent !== null && funnel.conversion_percent !== undefined) {
                      {{ funnel.conversion_percent | number: "1.1-2" }}%
                    } @else {
                      Sem base mensurável.
                    }
                  </p>
                  <p class="marketing-hint">
                    Coorte pela primeira visualização medida no período, com etapas em ordem na mesma sessão. Compras
                    confirmadas pelo backend até {{ funnel.metadata.as_of | date: "dd/MM/yyyy HH:mm" : "-0300" }}, em
                    até 30 dias. Apenas sessões medidas; não representa todos os visitantes ou pedidos. Histórico sem
                    coleta não é reconstruído.
                  </p>
                } @else {
                  <p class="marketing-hint">
                    @if (funnel.reason === "funnel_limit") {
                      Funil excede o limite de sessões/etapas. Reduza o período. Os totais de pedidos e receita
                      continuam completos.
                    } @else {
                      Funil indisponível para filtros de meio de pagamento ou canal sem denominador de sessões online.
                    }
                  </p>
                }
              </details>
            }
            <p-table [value]="result.rows" [scrollable]="true" class="p-datatable-striped">
              <ng-template pTemplate="header">
                <tr>
                  <th>Origem</th>
                  <th>Meio</th>
                  <th>Campanha</th>
                  <th>Canal</th>
                  <th>Pedidos</th>
                  <th>Unidades</th>
                  @if (!hideMoney) {
                    <th>Receita de ingressos</th>
                    <th>Receita estornada</th>
                    <th>Após estornos</th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.source || "Sem origem identificada" }}</td>
                  <td>{{ row.medium || "—" }}</td>
                  <td>{{ row.campaign || "—" }}</td>
                  <td>{{ channel(row.sale_channel) }}</td>
                  <td>{{ row.orders }}</td>
                  <td>{{ row.commercial_units }}</td>
                  @if (!hideMoney) {
                    <td>{{ row.ticket_revenue_cents / 100 | currency: "BRL" }}</td>
                    <td>{{ row.refund_cents / 100 | currency: "BRL" }}</td>
                    <td>{{ row.revenue_after_refunds_cents / 100 | currency: "BRL" }}</td>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="hideMoney ? 6 : 9">
                    Nenhuma compra no período selecionado. Não existem dados de demonstração neste relatório.
                  </td>
                </tr></ng-template
              >
            </p-table>
          </div>
          @if (result.pagination; as pagination) {
            <div class="marketing-pagination">
              <app-button
                styleType="outlined"
                icon="pi pi-angle-left"
                [disabled]="page <= 1 || busy"
                (btnClick)="movePage(-1)"
                >Anterior</app-button
              ><span>Página {{ page }} · {{ pagination.total }} grupos</span
              ><app-button
                styleType="outlined"
                icon="pi pi-angle-right"
                [disabled]="page * pagination.per_page >= pagination.total || busy"
                (btnClick)="movePage(1)"
                >Próxima</app-button
              >
            </div>
          }
          @if (!hideMoney) {
            <p class="marketing-hint">
              Receita de ingressos não é saldo da carteira. Ajustes de reembolso referem-se às compras do período e ao
              conhecimento até a geração do relatório. Combos contam como pacotes comerciais.
            </p>
          }
          @if (result.metadata.unattributed_reasons) {
            <div class="marketing-reasons">
              <strong>Sem atribuição / direto:</strong>
              @for (reason of result.metadata.unattributed_reasons | keyvalue; track reason.key) {
                <span>{{ reasonLabels[reason.key] || reason.key }}: {{ reason.value }}</span>
              }
            </div>
          }
          @if (result.order_rows; as orders) {
            <div class="marketing-table">
              <h3>ORIGEM POR PEDIDO</h3>
              <p class="marketing-hint">
                Primeiro e último toque congelados na compra. Pedidos antigos sem captura não têm uma origem
                reconstruída.
              </p>
              <app-button styleType="outlined" icon="pi pi-download" [disabled]="busy" (btnClick)="download('order')"
                >Baixar pedidos e toques</app-button
              >
              <p-table [value]="orders" [scrollable]="true" class="p-datatable-striped">
                <ng-template #header
                  ><tr>
                    <th>Pedido</th>
                    <th>Pagamento</th>
                    <th>Primeiro toque</th>
                    <th>Último toque</th>
                    @if (!hideMoney) {
                      <th>Receita de ingressos</th>
                    }
                  </tr></ng-template
                >
                <ng-template #body let-order
                  ><tr>
                    <td>#{{ order.order_id }}</td>
                    <td>{{ order.occurred_at | date: "dd/MM/yyyy HH:mm" : "-0300" }}</td>
                    <td>
                      {{ order.first_touch?.source || "Sem captura"
                      }}<small class="d-block">{{ order.first_touch?.campaign || "" }}</small>
                    </td>
                    <td>
                      {{ order.last_touch?.source || "Sem captura"
                      }}<small class="d-block">{{ order.last_touch?.campaign || "" }}</small>
                    </td>
                    @if (!hideMoney) {
                      <td>{{ order.ticket_revenue_cents / 100 | currency: "BRL" }}</td>
                    }
                  </tr></ng-template
                >
                <ng-template #emptymessage
                  ><tr>
                    <td [attr.colspan]="hideMoney ? 4 : 5">Nenhum pedido no período.</td>
                  </tr></ng-template
                >
              </p-table>
              @if (result.order_pagination; as pagination) {
                <div class="marketing-pagination">
                  <app-button styleType="clean" [disabled]="orderPage <= 1 || busy" (btnClick)="movePage(-1, 'order')"
                    >Anterior</app-button
                  ><span>Página {{ orderPage }} · {{ pagination.total }} pedidos</span
                  ><app-button
                    styleType="clean"
                    [disabled]="orderPage * pagination.per_page >= pagination.total || busy"
                    (btnClick)="movePage(1, 'order')"
                    >Próxima</app-button
                  >
                </div>
              }
            </div>
          }
          <p class="marketing-hint">
            {{ result.metadata.model }} · {{ result.metadata.monetary_policy_version }} · Gerado em
            {{ result.metadata.generated_at | date: "dd/MM/yyyy HH:mm" : "-0300" }}. Histórico sem evidência não é
            reconstruído.
          </p>
        }
      </section>
    }
  </ng-template>
  <ng-template #integrationsPanel>
    @if (tab === "integrations") {
      <section class="social-media-module" aria-label="Integrações social media">
        <p class="marketing-intro">
          Cadastre e edite as integrações deste evento. Os cadastros novos são exclusivos dele e não alteram outros
          eventos.
        </p>
        @if (busy && !integrationsLoaded) {
          <div class="marketing-integration-grid" role="status" aria-label="Carregando integrações">
            @for (provider of providers; track provider.key) {
              <div class="marketing-provider marketing-provider-loading">
                <p-skeleton height="2.5rem" width="60%" /><p-skeleton height="1rem" />
                <p-skeleton height="7rem" /><p-skeleton height="2.5rem" />
              </div>
            }
          </div>
        } @else if (integrationsLoaded) {
          <div class="marketing-integration-grid">
            @for (provider of providers; track provider.key) {
              @let integration = current(provider.key);
              <article class="marketing-provider" [attr.data-provider]="provider.key">
                <header class="marketing-provider-header">
                  <img class="marketing-provider-logo" [src]="provider.logo" alt="" width="40" height="40" />
                  <div class="marketing-provider-name">
                    <h4>{{ provider.name }}</h4>
                    @if (provider.description) {
                      <p>{{ provider.description }}</p>
                    }
                  </div>
                  <span class="marketing-badge" [class.marketing-badge-enabled]="integration?.enabled">
                    {{ cardStatus(provider.key) }}
                  </span>
                </header>
                <div class="marketing-provider-body">
                  <label class="form-label" [for]="'card-registration-' + provider.key">Cadastro deste evento</label>
                  <select
                    class="form-select"
                    [id]="'card-registration-' + provider.key"
                    [ngModel]="selected[provider.key]"
                    (ngModelChange)="selectIntegration(provider.key, $event)"
                    [disabled]="busy">
                    <option [ngValue]="undefined">Selecione um cadastro</option>
                    @for (registration of forProvider(provider.key); track registration.id) {
                      <option [ngValue]="registration.id">
                        {{ registration.display_name }}{{ registration.enabled ? "" : " · desabilitado" }}
                      </option>
                    }
                  </select>
                  <dl class="marketing-card-data">
                    <div>
                      <dt>{{ provider.key === "google" ? "Ação de conversão" : "Pixel ID" }}</dt>
                      <dd>
                        {{
                          integration?.public_configuration?.["conversion_id"] ||
                            integration?.public_configuration?.["pixel_id"] ||
                            "Não configurado"
                        }}
                      </dd>
                    </div>
                    <div>
                      <dt>Capacidade do cadastro</dt>
                      <dd>
                        {{ integration ? capability(integration.capability_status) : "Nenhum cadastro selecionado" }}
                      </dd>
                    </div>
                    <div>
                      <dt>Conta</dt>
                      <dd>{{ integration?.display_name || "Cadastre uma integração neste evento" }}</dd>
                    </div>
                  </dl>
                  <footer class="marketing-provider-footer">
                    <label class="marketing-event-use">
                      <input
                        type="checkbox"
                        [checked]="!!draftBindings[provider.key]?.enabled"
                        [disabled]="
                          readOnly ||
                          busy ||
                          !integration ||
                          (!integration.enabled && !draftBindings[provider.key]?.enabled)
                        "
                        (change)="setEventEnabled(provider.key, $any($event.target).checked)" />
                      <span
                        ><strong>Usar neste evento</strong>
                        @if (eventName) {
                          <small>{{ eventName }}</small>
                        }
                      </span>
                    </label>
                    @if (!readOnly) {
                      <div class="marketing-card-actions">
                        <app-button
                          data-testid="create-event-registration"
                          [disabled]="busy"
                          (btnClick)="editRegistration(provider.key)"
                          >NOVO CADASTRO</app-button
                        >
                        @if (integration) {
                          <app-button
                            data-testid="edit-event-registration"
                            [disabled]="busy"
                            styleType="clean"
                            (btnClick)="editRegistration(provider.key, integration)"
                            >EDITAR CADASTRO</app-button
                          >
                          <app-button [disabled]="busy" styleType="clean" (btnClick)="toggleRegistration(integration)">
                            {{ integration.enabled ? "DESABILITAR CADASTRO" : "HABILITAR CADASTRO" }}
                          </app-button>
                        }
                        <app-button
                          data-testid="configure-event-integration"
                          [disabled]="busy"
                          (btnClick)="manage(provider.key)"
                          >CONFIGURAR NESTE EVENTO</app-button
                        >
                      </div>
                    }
                  </footer>
                </div>
              </article>
            }
          </div>
        }
        <div class="marketing-security-note">
          <img src="assets/marketing/social-media/info.svg" alt="" width="18" height="18" />
          <p>
            Cadastros e envios pertencem somente a este evento. Alterações aqui não modificam outros eventos.
          </p>
        </div>
      </section>
    }
  </ng-template>
  <ng-template #integrationSettings>
    <app-dialog-header title="Integração deste evento" [disabled]="busy" />
    <mat-dialog-content class="marketing-settings">
      @if (error) {
        <p class="marketing-error" role="alert">{{ error }}</p>
      }
      @if (notice) {
        <p class="marketing-notice" role="status">{{ notice }}</p>
      }
      @for (provider of providers; track provider.key) {
        @if (provider.key === managingProvider) {
          @if (forProvider(provider.key).length) {
            <label class="form-label" [for]="'integration-' + provider.key">Cadastro deste evento</label>
            <select
              class="form-select"
              [id]="'integration-' + provider.key"
              [ngModel]="selected[provider.key]"
              (ngModelChange)="selectIntegration(provider.key, $event)"
              [disabled]="busy || readOnly">
              <option [ngValue]="undefined">Selecione um cadastro</option>
              @for (integration of forProvider(provider.key); track integration.id) {
                <option [ngValue]="integration.id">{{ integration.display_name }}</option>
              }
            </select>
            @if (current(provider.key); as integration) {
              <div class="marketing-integration-state">
                <span class="marketing-badge" [class.marketing-badge-enabled]="integration.enabled">
                  {{ integration.enabled ? "Cadastro habilitado" : "Cadastro desabilitado" }}
                </span>
                <p>{{ capability(integration.capability_status) }}</p>
              </div>
              @if (draftBindings[provider.key]; as draft) {
                <div class="marketing-binding">
                  <h5>Configuração deste evento</h5>
                  <label class="marketing-check"
                    ><input
                      class="form-check-input"
                      type="checkbox"
                      [(ngModel)]="draft.enabled"
                      [disabled]="busy || readOnly || (!integration.enabled && !draft.enabled)" />
                    Ativar integração neste evento</label
                  >
                  <p class="marketing-hint">Ao ativar, o pixel / tag envia pelo navegador conforme o consentimento do comprador.</p>
                  @if (!integration.enabled) {
                    <p class="marketing-warning">
                      Cadastro desabilitado. Habilite-o neste evento antes de iniciar envios.
                    </p>
                  }
                  <h5>Eventos enviados</h5>
                  @for (event of journeyEvents; track event.key) {
                    <label class="marketing-check"
                      ><input
                        class="form-check-input"
                        type="checkbox"
                        [ngModel]="draft.allowed_events.includes(event.key)"
                        [disabled]="busy || readOnly"
                        (ngModelChange)="toggleEvent(provider.key, event.key, $event)" />
                      {{ event.label }}</label
                    >
                  }
                  @if (!readOnly) {
                    <app-button icon="pi pi-save" [disabled]="busy" (btnClick)="saveBinding(provider.key)"
                      >Salvar vínculo do evento</app-button
                    >
                  }
                </div>
              }
            }
          } @else {
            <div class="marketing-empty-integration">
              <span class="marketing-badge">Não configurada</span>
              <p>
                Nenhum cadastro {{ provider.name }} disponível. Feche este painel e clique em Novo cadastro neste
                evento.
              </p>
            </div>
          }
        }
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end"
      ><app-button styleType="outlined" [disabled]="busy" (btnClick)="closeSettings()"
        >Fechar</app-button
      ></mat-dialog-actions
    >
  </ng-template>
</div>
